import { MohPopupTriggeredNotificationType } from 'src_server/types/notificationData';

export const MOH_POPUP_TRIGGERS_CHANNEL = 'moh-popup-triggers';
export const MOH_POPUP_TRIGGERED_TYPE = 'moh-popup-triggered';

export const isMohPopupTriggeredNotification = (notification: {
    type: string;
}): notification is MohPopupTriggeredNotificationType => {
    return notification.type === MOH_POPUP_TRIGGERED_TYPE;
};

export const getMohPopupTriggeredNotificationEntity = (
    notification: MohPopupTriggeredNotificationType
): typeof MOH_POPUP_TRIGGERED_TYPE => {
    return notification.type;
};
